export default __webpack_public_path__ + "static/media/038-gingerbread man.6ad5f1bf.svg";